import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { CoverageRuleAction } from '../coverageRule.action';

// After a successful save, reload the rule set from the backend (same as routing rules) so
// the grid leaves the edited state and shows the persisted rules with fresh validation.
export const reloadCoverageRuleEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(CoverageRuleAction.update.done),
  mergeMap(({ params }) => [CoverageRuleAction.loadList.started({ ruleSetId: params.ruleSetId })]),
);
